module.exports = "https://coursera_assets.s3.amazonaws.com/images/e0aa0adac07ec48e85c01b8e8f455975.png";